import React from "react";

export default function SQL_Quick_Ref() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_Quick_Ref</h1>
      <p>This is the SQL_Quick_Ref component generated from the SQL JSON.</p>
    </div>
  );
}
